import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["imageableType", "imageableId"]

    declare imageableTypeTarget: HTMLSelectElement
    declare imageableIdTarget: HTMLSelectElement

    allOptions: any[] = []

    connect() {
        this.allOptions = Array.from(this.imageableIdTarget.options).map(opt => ({
            value: opt.value,
            text: opt.text,
            type: opt.value.split('-')[0]
        }));
        this.filterOptions()
        this.imageableTypeTarget.addEventListener('change', this.filterOptions.bind(this))
    }

    disconnect() {
        this.imageableTypeTarget.removeEventListener('change', this.filterOptions.bind(this))
    }

    filterOptions() {
        const selectedType = this.imageableTypeTarget.value;
        this.imageableIdTarget.innerHTML = '';
        this.allOptions
            .filter(opt => opt.type === selectedType)
            .forEach(opt => {
                const option = document.createElement('option');
                option.value = opt.value;
                option.text = opt.text;
                this.imageableIdTarget.appendChild(option);
            });
    }

}
